<h1 class="text-center">{{message('ingredientsHeader')}}</h1>

<form>
  <div class="form-group">
    <div id="ingredients">
      <div class="row mx-auto form-group">
        <div class="col">
          <img [alt]="message('calorieCostLabel')" class="calorieSprite mr-2" [src]="imageTemplateUrl"
          [ngStyle]="{'background': 'url(' + getCalorieSpriteImageUrl() + ') no-repeat -416px -160px / 512px'}">
          <label for="laborInput">
            <strong>{{message('calorieCostLabel')}}</strong>
          </label>
        </div>
        <div class="col">
          <input #laborBox (focusout)="onLaborCostChange(laborBox.value)"
                 [value]="laborCost.toLocaleString(locale.code)"
                 class="priceInput form-control float-right dark-input" id="laborInput"
                 pattern="[0-9]*[.,]?[0-9]+" type="text">
        </div>
      </div>
      <div class="row laborRow divider mx-auto form-group">
        <div class="col">
          <img [alt]="message('profitPercentLabel')" class="profitSprite mr-2" [src]="imageTemplateUrl"
               [ngStyle]="{'background': 'url(' + getProfitSpriteImageUrl() + ') no-repeat -320px -384px / 512px'}">
          <label for="profitInput">
            <strong>{{message('profitPercentLabel')}}</strong>
          </label>
        </div>
        <div class="col">
          <input #profitBox (focusout)="onProfitPercentChange(profitBox.value)"
                 [value]="profitPercent.toLocaleString(locale.code)"
                 class="priceInput form-control float-right dark-input" id="profitInput"
                 pattern="[0-9]*[.,]?[0-9]+" type="text">
        </div>
      </div>
      <div class="row laborRow divider mx-auto form-group">
        <div class="col">
          <img [alt]="message('taxPercentLabel')" class="profitSprite mr-2" src="assets/img/32px-template.png">
          <label for="taxInput">
            <strong>{{message('taxPercentLabel')}}</strong>
          </label>
        </div>
        <div class="col">
          <input #taxBox (focusout)="onTaxPercentChange(taxBox.value)"
                 [value]="taxPercent.toLocaleString(locale.code)"
                 class="priceInput form-control float-right dark-input" id="taxInput"
                 pattern="[0-9]*[.,]?[0-9]+" type="text">
        </div>
        <div class="col">
          <img [alt]="message('rebatePercentLabel')" class="profitSprite mr-2" src="assets/img/32px-template.png">
          <label for="rebateInput">
            <strong>{{message('rebatePercentLabel')}}</strong>
          </label>
        </div>
        <div class="col">
          <input #rebateBox (focusout)="onRebatePercentChange(rebateBox.value)"
                 [value]="rebatePercent.toLocaleString(locale.code)"
                 class="priceInput form-control float-right dark-input" id="rebateInput"
                 pattern="[0-9]*[.,]?[0-9]+" type="text">
        </div>
      </div>
      <div *ngFor="let ingredient of itemIngredients" class="row ingredientRow mx-auto form-group">
        <div class="col-8">
          <img [alt]=ingredient.name [ngStyle]="{'background': 'url(' + getItemImageUrl(ingredient) + ') no-repeat',
                'background-position': getItemSpritePosition(ingredient),
                'background-size': getItemBackgroundSize(ingredient),
                'filter': getItemFilter(ingredient)}"
               class="itemSprite mr-2" [src]="imageTemplateUrl">
          <label *ngIf="ingredient.tag; else nonTagName" for="{{ingredient.nameID}}-priceInput">
            {{ingredient.name}}<span class="material-icons tagIcon">sell</span>
          </label>
          <ng-template #nonTagName>
            <label for="{{ingredient.nameID}}-priceInput">
              {{ingredient.name}}
            </label>
          </ng-template>
        </div>
        <div class="col">
          <input #priceBox (focusout)="onPriceChange(ingredient, priceBox.value)"
                 [value]="ingredient.price.toLocaleString(locale.code)"
                 class="priceInput form-control float-right dark-input" id="{{ingredient.nameID}}-priceInput"
                 pattern="[0-9]*[.,]?[0-9]+" type="text">
        </div>
      </div>
    </div>
  </div>
</form>

